<template>
  <label
    v-bind="attributes"
    :name="name"
    class="flex cursor-pointer"
  >
    <span
      class="ocheckbox"
      :class="{ 'ocheckbox-checked': value }"
    >
      <input :checked="value" type="checkbox" @input="$emit('input', $event)">
      <div class="hidden ocheckbox-box" />
    </span>
    <slot />
  </label>
</template>

<script>
export default {
  name: 'OCheckBox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    attribute: {
      type: Object,
      default: null,
      validator: value => ['name', 'value'].every(prop => value.hasOwnProperty(prop))
    },
    name: {
      type: String,
      default: 'checkbox'
    }
  },
  computed: {
    attributes () {
      return {
        ...(this.attribute ? { [this.attribute.name]: this.attribute.value } : {})
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.ocheckbox {
  @apply border-1 border-neutral-800 text-neutral-800 block rounded-sm cursor-pointer relative flex-shrink-0;
  height: 1.8rem;
  width: 1.8rem;

  &-box {
    @apply bg-transparent;
    transition: all 0.2s ease-in-out;
  }

  input {
    @apply appearance-none;
  }
}

.ocheckbox-checked {
  .ocheckbox-box {
    @apply block absolute rounded-sm bg-gray-600;
    transition: all 0.2s ease-in-out;
    height: 1rem;
    width: 1rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
